
/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, UPCOMING_EVENTS_MONTHS } from "../../framework/constant/constant";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from "../../locale/useTranslation";
import CancelButton from "../../framework/forms/helpercomponents/buttons/CancelButton";

export const CommercialConsumptionReport = () => {

    const navigate = useNavigate();
    const lang = useTranslation();
    const currentYear = new Date().getFullYear();
    const currentMonthIndex = new Date().getMonth(); 
    const currentMonthName = Object.keys(UPCOMING_EVENTS_MONTHS)[currentMonthIndex];
    const currentMonthValue = UPCOMING_EVENTS_MONTHS[currentMonthName];

    const blankDataItem = {
        Year: { _id: currentYear, Description: currentYear.toString() },
        Month: { _id: currentMonthValue, Description: currentMonthName },
        Channel: {},
        Agency: {}
    };
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [channel, setChannel] = useState([]);
    const [agency, setAgency] = useState([]);
    const [years, setYears] = useState([]);
    const [months, setMonths] = useState([]);
    const selectedChannelRef = useRef();
    const setSelectedChannelRef = (data) => {
        selectedChannelRef.current = data;
    }
    const payloadRef = useRef({});
    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        const channelRes = await API.getDataLookup(ENTITYNAME.Channel, { sort: { FullChannelName: 1 } });
        setChannel(channelRes.data);
    
        const agencyRes = await API.getDataLookup(ENTITYNAME.Agency, { sort: { Name: 1 } });
        setAgency(agencyRes.data);

        const monthRes = Object.keys(UPCOMING_EVENTS_MONTHS).map(x => ({
            _id: UPCOMING_EVENTS_MONTHS[x],
            Description: x
        }));
        setMonths(monthRes);
    
        generateYearOptions();
    };

    const onChange = async (e) => {
        if (e.target.name == 'Channel') {
            setSelectedChannelRef(e.target.value)
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const generateYearOptions = () => {
        const currentYear = new Date().getFullYear();
        const yearOptions = [];
        for (let year = currentYear - 3; year <= currentYear + 5; year++) {
            yearOptions.push({ _id: year, Description: year.toString() });
        }
        setYears(yearOptions);
    };
 
    const isValid = () => {
        if (Object.keys(dataItem.Channel).length == 0) {
            toast.error(`${lang.please_select_channel_error_message}`, {
                position: toast.POSITION.TOP_RIGHT
            });
            return false;
        }

        return true
    }

    const commercialConsumptionExportData = async () => {
        if (isValid()) {
            payloadRef.current = {
                Year: dataItem?.Year,
                Month: dataItem?.Month,
                channelsid: selectedChannelRef?.current?.SID,
                channelName: selectedChannelRef?.current?.FullChannelName,
                Agency: dataItem?.Agency
            }
            loadCommercialConsumptionData();
        }
    }

    const loadCommercialConsumptionData = async () => {
        let payload = {
            ...payloadRef.current,
        }

        let res = await API.getCommercialConsumptionReport(payload);
        if (res.success) {
            if (res.dataLength == 0) {
                toast.info(`${lang.no_data_found_for_selected_filter_error_message}`, {
                    position: toast.POSITION.TOP_RIGHT
                });
                return;
            }
            else {
                window.open(FILEURL.BASEURL + 'downloadReport/' + res.data)
                toast.success('Successfully Exported!', {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
        }
        else {
            toast.error(res.message, {
                position: toast.POSITION.TOP_RIGHT
            });
        }
    };

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.commercial_consumption_report_header}</span>
        </h1>
        <div className="col-12" style={{ margin: "02px 0px 0px 0px" }}>
            <div className="row">
                <div className="flex-container wrap">
                    <div className="row mt-1 mb-1" style={{ marginLeft: '-16px' }}>
                        <div className="col">
                            <ActionButton title={lang.download_commercial_consumption_report_tooltip_button} name={lang.export_button_text} btnColor={'info'} onClick={commercialConsumptionExportData} />
                            <CancelButton onClick={() => navigate(-1)}></CancelButton>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row mt-3">
                <div className="col-3">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.year_label} *</label>
                        <DropDownList
                            data={years}
                            name='Year'
                            dataItemKey='_id'
                            textField='Description'
                            onChange={onChange}
                            value={dataItem.Year}
                            style={{ backgroundColor: 'white' }}
                        />
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.month_label} *</label>
                        <DropDownList
                            data={months}
                            name='Month'
                            dataItemKey='_id'
                            textField='Description'
                            onChange={onChange}
                            value={dataItem.Month}
                            style={{ backgroundColor: 'white' }}
                        />
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.channel_label} *</label>
                        <DropDownList
                            data={channel}
                            name={"Channel"}
                            textField="FullChannelName"
                            dataItemKey="_id"
                            value={dataItem.Channel}
                            onChange={onChange}
                            style={{ backgroundColor: "white" }}
                        />
                    </div>
                </div>
                <div className="col-3">
                    <div className="form-group">
                        <label htmlFor="TabView">{lang.agency_label}</label>
                        <DropDownList
                            style={{ backgroundColor: "white" }}
                            data={agency}
                            name="Agency"
                            textField="Name"
                            dataItemKey="_id"
                            value={dataItem.Agency}
                            onChange={onChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    </>)
}
export default CommercialConsumptionReport;